import React, { useCallback } from 'react';
import Typography from '@material-ui/core/Typography';
import { Accordion, AccordionSummary, AccordionDetails, Grid } from '@material-ui/core'
import { useHistory } from "react-router-dom";

import { News } from '../../utils/services/cache/ClientCache'
import useStyles from '../../styles/components/news/stylesTopNewsHolder'

const TopNewsHolder = ({ news }) => {

    const history = useHistory()
    const classes = useStyles();

    const handleClick = useCallback(() => {
        News.setNewsId(news.id)
        history.push('/NewsDetail')
    }, [])

    return (
        <>
            <Grid item xs={4}>
                <Accordion
                    expanded={true}
                    classes={{
                        root: classes.rootAccordion,
                        rounded: classes.roundedAccordion
                    }} style={{ cursor: 'pointer' }} onClick={handleClick}
                >
                    <AccordionSummary
                        classes={{
                            root: classes.rootAccordionSummary,
                            content: classes.contentAccordionSummary,
                            expanded: classes.expandedAccordionSummary,
                        }}
                    >
                        <img src={news.bannerUrl} alt={news.title} className={classes.image} />
                    </AccordionSummary>
                    <AccordionDetails style={{ height: '130px' }}>
                        <Typography classes={{ root: classes.rootTypographyTitle }}> {news.title} </Typography>
                    </AccordionDetails>
                </Accordion>
            </Grid>
            
        </>
    );
};

export { TopNewsHolder as default }